<div>
    <h3>
        Merchant Applications
    </h3>

    <app-reusable-grid [dataSource]="merchantsDataSource" [columns]="columns" [pageSize]="15"
        [Id]="ActionIDs.MerchantComplience" (rowClicked)="navigateToDetails($event)">
    </app-reusable-grid>
</div>